import { AddressesSummary } from "@components/AddressesSummary";
import { InfoCard } from "@components/InfoCard";
import React from "react";

export const ContactUs = () => {
    return (
        <div className="mx-auto max-w-screen-xl min-w-[100%]">
            <div className="pt-20"></div>
            <h2 className="text-4xl font-bold mb-4">Kontakt</h2>

            <div className="w-full"  data-aos="fade-right">
                <InfoCard
                    image="./images/vaterguirgis.png"
                    headerText={"Vorstand: Vater Girgis El Moharaki"}
                    pa={"E-Mail: girgiselmoharaky@hotmail.com"}
                    pb={"Mobil: +49 171 4360460"}
                />
            </div>

            <div className="pt-2"></div>
            <div className="w-full"  data-aos="fade-left">

                <InfoCard
                    image="./images/drsameh.png"
                    headerText={"Vorstand: Dr. Sameh Iskander"}
                    pa={"E-Mail: dr.iskander@koptische-gemeinde.de"}
                    pb={"Mobil: +49 178 1581273"}
                />
            </div>
            <AddressesSummary title={"Wo Finden Sie Uns?"} />
        </div>
    )
}